"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var spaui_utils_1 = require("@tencent/spaui-utils");
var info_1 = __importDefault(require("./info"));
var odc_frame_1 = __importDefault(require("@tencent/odc-frame"));
var CardBoxComponent = function CardBoxComponent(props) {
  var children = props.children,
    restProps = __rest(props, ["children"]);
  return react_1["default"].createElement(odc_frame_1["default"], __assign({}, restProps, (0, spaui_utils_1.globalProps)(props, {
    className: 'odc-card-box',
    supportAllEvents: true
  }, CardBoxComponent)), children);
};
(0, spaui_utils_1.setComponentMark)(CardBoxComponent, info_1["default"]);
exports["default"] = react_1["default"].memo(CardBoxComponent);